import React from 'react';
import './styles.scss';

const insuranceLogos = [
  { src: '/2025/insurances/icons/Generali.svg', alt: 'Generali' },
  { src: '/2025/insurances/icons/Groupama.svg', alt: 'Groupama' },
  { src: '/2025/insurances/icons/alianz.svg', alt: 'Allianz' },
  { src: '/2025/insurances/icons/UNIQA.svg', alt: 'UNIQA' },
  { src: '/2025/insurances/icons/bulstrad.svg', alt: 'Булстрад Vienna Insurance Group' },
];

const Insurance = () => {
  return (
    <section className="insurance-section">
      <div className="insurance-content">
        <h2 className="insurance-title">
          Core система в застраховането
        </h2>
        
        <div className="insurance-text">
          <p>
            На база утвърдения ни опит в дигиталното управление на всички оперативни и стратегически процеси при застрахователните брокери през началото на 2026-та година ще представим на пазара уникална по рода си система за застрахователна компания - съвременна и иновативна, както винаги се очаква от екипа на fidweb.
          </p>
        </div>
      </div>
      
      {/* Logo Marquee - infinite scrolling */}
      <div className="logo-marquee">
        <div className="logo-track">
          {/* First set of logos */}
          {insuranceLogos.map((logo, index) => (
            <img 
              key={`logo-1-${index}`}
              src={logo.src} 
              alt={logo.alt}
              className="logo-item"
            />
          ))}
          {/* Duplicate for seamless loop */}
          {insuranceLogos.map((logo, index) => (
            <img 
              key={`logo-2-${index}`}
              src={logo.src} 
              alt={logo.alt}
              className="logo-item"
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Insurance;
